/* eslint-disable prettier/prettier */
import { Stack, Text, TextInput, Group, Title, Divider } from "@mantine/core";
import TelInput from "@/components/tel-input";
import { AdminStepProperties } from "../types";

export const AdminUserStep = ({ form }: AdminStepProperties) => {
  return (
    <Stack gap="sm" mt="md">
      <Title order={3} mb="xs">Passo 4: Usuário Administrador</Title>
      <Text size="sm" c="dimmed" mb="md">
        Este usuário será criado automaticamente com permissões de administrador e será o responsável pela licenciada. Receberá um convite por email.
      </Text>
      <Divider mb="md" />
      <TextInput label="Nome do Administrador/Responsável" {...form.getInputProps("admin.nome")} required />
      <Group grow>
        <TextInput label="Email do Administrador/Responsável" type="email" {...form.getInputProps("admin.email")} required />
        <TelInput label="Telefone do Administrador/Responsável" {...form.getInputProps("admin.telefone")} required />
      </Group>
    </Stack>
  );
};
